import SurveyIcon from './SurveyIcon';
export default SurveyIcon;
export const canvasSize = 14;
export const heatMapCanvasSize = 64;
export function getCanvasSize(props) {
  return [
    'circle',
    'diamond',
    'frown',
    'neutral',
    'smile',
    'square',
    'star',
    'triangle',
  ].includes(props.icon)
    ? heatMapCanvasSize
    : canvasSize;
}
